















































































































import axios from 'axios';
import Vue, { PropType } from 'vue';
import { AppConfiguration, PasswordResetRequest } from '../common/types';
import { RequestHeader, Response } from '../common/types';
import { CsrfHelper } from '../common/helpers';

const csrfHelper = new CsrfHelper();

export default Vue.extend({
  props: {
    appConfig: {
      type: Object as PropType<AppConfiguration>,
    },
  },
  data: () => ({
    csrfHeaders: null as RequestHeader | null,
    formValid: false,
    resetFormValid: false,
    resetFormVisible: false,
    username: '',
    password: '',
    resetUsername: '',
    submitting: false,
    resetSubmitting: false,
    resetSnackbarVisible: false,
    resetMessage: '',
    usernameRules: [(v: string) => !!v || 'Please enter your username'],
    passwordRules: [(v: string) => !!v || 'Please enter your password'],
  }),
  computed: {
    config() {
      return this.appConfig;
    },
  },
  mounted: function () {
    this.csrfHeaders = csrfHelper.getCsrfHeader();
  },
  methods: {
    submit(): void {
      this.submitting = true;
    },
    passwordReset(): void {
      this.resetSubmitting = true;
      const request: PasswordResetRequest = {
        username: this.resetUsername,
        password: null,
        token: null,
        newPassword: null,
      };

      axios
        .post<Response>('api/password/token', request, { headers: this.csrfHeaders })
        .then((response) => {
          if (response.data.code === 1) {
            this.resetMessage = `An email will be sent if the username "${this.resetUsername}" is found in the system.`;
          } else {
            this.resetMessage = response.data.message;
          }
        })
        .catch(() => {
          this.resetMessage =
            'An error occured while initiating a password reset. Reload the page and try again.';
        })
        .finally(() => {
          this.resetSubmitting = false;
          this.resetSnackbarVisible = true;
        });
    },
  },
});
